export function getContrastTextColor(backgroundColor: string): string {
  // Parse the color string to RGB values
  const rgb = parseColor(backgroundColor);

  // Calculate relative luminance using WCAG formula
  const luminance = getRelativeLuminance(rgb);

  // Return white for dark backgrounds, black for light backgrounds
  // Threshold of 0.5 provides good contrast in most cases
  return luminance > 0.5 ? "#000000" : "#ffffff";
}

/**
 * Parses various color formats (hex, rgb, rgba, named colors) to RGB
 */
function parseColor(color: string): { r: number; g: number; b: number } {
  // Create a temporary element to use browser's color parsing
  const temp = document.createElement("div");
  temp.style.color = color;
  document.body.appendChild(temp);

  const computed = window.getComputedStyle(temp).color;
  document.body.removeChild(temp);

  // Parse the rgb/rgba format returned by getComputedStyle
  const match = computed.match(/\d+/g);

  if (!match || match.length < 3) {
    throw new Error(`Invalid color format: ${color}`);
  }

  return {
    r: parseInt(match[0]),
    g: parseInt(match[1]),
    b: parseInt(match[2]),
  };
}

/**
 * Calculates relative luminance using WCAG formula
 * https://www.w3.org/WAI/GL/wiki/Relative_luminance
 */
function getRelativeLuminance(rgb: {
  r: number;
  g: number;
  b: number;
}): number {
  // Convert RGB to sRGB
  const rsRGB = rgb.r / 255;
  const gsRGB = rgb.g / 255;
  const bsRGB = rgb.b / 255;

  // Apply gamma correction
  const r =
    rsRGB <= 0.03928 ? rsRGB / 12.92 : Math.pow((rsRGB + 0.055) / 1.055, 2.4);
  const g =
    gsRGB <= 0.03928 ? gsRGB / 12.92 : Math.pow((gsRGB + 0.055) / 1.055, 2.4);
  const b =
    bsRGB <= 0.03928 ? bsRGB / 12.92 : Math.pow((bsRGB + 0.055) / 1.055, 2.4);

  // Calculate luminance
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
